import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons'
import { Button } from '@karnov/kui-react'

import { UserCarouselSlug } from 'api/userCarousels/types'
import { useTranslation } from 'services/i18n'

import type { FC } from 'react'

type Props = {
  carouselSlug: UserCarouselSlug
  onClick: (carouselSlug: UserCarouselSlug) => void
}

export const UserCarouselButton: FC<Props> = ({ carouselSlug, onClick }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'help_and_feedback.dropdown_options',
  })

  return (
    <Button
      aria-label={t(`user_carousel_${carouselSlug}`)}
      icon={faCircleInfo}
      isSmall
      onClick={() => onClick(carouselSlug)}
      variant="plain"
    >
      {t(`user_carousel_${carouselSlug}`)}
    </Button>
  )
}
